import { render, staticRenderFns } from "./view-code.vue?vue&type=template&id=318406b9"
import script from "./view-code.vue?vue&type=script&lang=js"
export * from "./view-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports